"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PersonalisationConfigurator", {
  enumerable: true,
  get: function get() {
    return _configurator.default;
  }
});
Object.defineProperty(exports, "SegmentsSelector", {
  enumerable: true,
  get: function get() {
    return _SegmentsSelector.default;
  }
});

var _SegmentsSelector = _interopRequireDefault(require("./SegmentsSelector"));

var _configurator = _interopRequireDefault(require("./configurator"));